'use strict';
/**
 *  Load modules
 */

import burgerMenu from './modules/burgerMenu.js';
import openClose from './modules/openClose.js';
import stickyHeader from './modules/stickyHeader'; // import simpleParallax from './modules/simpleParallax';

import listjs from './modules/sortList';
import carousel from './modules/carousel';
import customSelect from './modules/customSelect';
import dataTables from './modules/dataTables';
import counterUp from './modules/counterUp.js';
import '../scss/app.scss';
$(document).ready(function () {
  function wrapBtnNav() {
    if (jQuery(window).width() >= 1024) {
      var btn = jQuery('.navbar .navbar__btn');
      var lastItem = jQuery('.navbar__nav > li').last();
      btn.appendTo(lastItem);
    }
  }

  wrapBtnNav();

  if (jQuery('.job-board__table').length) {
    var openerText = jQuery('.job-board__table-mobile-opener strong');
    var firstButton = jQuery('.job-board__table-td button').eq(0).text();
    openerText.text(firstButton);
    jQuery('.job-board__table-td button').each(function () {
      var button = jQuery(this);
      button.on('click', function () {
        openerText.text(button.text());
      });
    });
  }

  jQuery('.filter-state select').on('change', function () {
    window.location.href = jQuery(this).val();
  });
  jQuery('.articles-filter__form-col select').on('change', function (e) {
    e.preventDefault();
    var text = 'ALL ARTICLES';
    var val = jQuery(this).val();

    if ('default' != val) {
      text = 'Articles Filtered by: ' + jQuery(this).find("option:selected").text();
    }

    var id = jQuery(this).attr('id');
    var data = {
      'action': 'articles_filter',
      'term_ID': val
    };
    jQuery('.cards .container>h3').text(text);
    jQuery.ajax({
      url: myajax.url,
      type: 'POST',
      data: data,
      dataType: "json",
      success: function success(result) {
        if (result) {
          jQuery('.cards__row').html(result.posts);
          jQuery('a.btn.btn_load_more').attr('data-count_posts', result.count);

          if (result.count < 7) {
            jQuery('a.btn.btn_load_more').hide();
          } else {
            jQuery('a.btn.btn_load_more').show();
          }

          jQuery('.articles-filter__form-col select').each(function (i) {
            if (jQuery(this).attr('id') != id) {
              jQuery(this).prop('selectedIndex', 0);
              jQuery(this).parent().find('.custom-select-opener span').text(jQuery(this).find('option:first').text());
              jQuery(this).parent().find('.custom-select-panel div').each(function (i) {
                jQuery(this).removeClass('is-selected has-focus');
              });
            }
          });
          jQuery('.articles-filter__form-col .not_filter ').removeClass('active');
          jQuery('.articles-filter__form-head [role="search"] [type="search"]').val('');
        }
      }
    });
  });
  jQuery('.articles-filter__form-head [role="search"]').on('submit', function (e) {
    e.preventDefault();
    var search = jQuery(this).find('[name="s"]').val();
    var text = 'Search: ' + search;
    var id = jQuery(this).attr('id');
    var data = {
      'action': 'search',
      'search': search
    };
    jQuery('.cards .container>h3').text(text);
    jQuery.ajax({
      url: myajax.url,
      type: 'POST',
      data: data,
      dataType: "json",
      success: function success(result) {
        if (result) {
          jQuery('.cards__row').html(result.posts);
          jQuery('a.btn.btn_load_more').attr('data-count_posts', result.count);

          if (result.count < 7) {
            jQuery('a.btn.btn_load_more').hide();
          } else {
            jQuery('a.btn.btn_load_more').show();
          }

          jQuery('.articles-filter__form-col select').each(function (i) {
            jQuery(this).prop('selectedIndex', 0);
            jQuery(this).parent().find('.custom-select-opener span').text(jQuery(this).find('option:first').text());
            jQuery(this).parent().find('.custom-select-panel div').each(function (i) {
              if (i == 0) {
                jQuery(this).addClass('is-selected has-focus');
              } else {
                jQuery(this).removeClass('is-selected has-focus');
              }
            });
          });
          jQuery('.articles-filter__form-col .not_filter ').removeClass('active');
        }
      }
    });
  });
  jQuery('.articles-filter__form-col .not_filter ').on('click', function (e) {
    e.preventDefault();
    jQuery(this).addClass('active');
    var id = jQuery(this).attr('id');
    var text = 'Articles Filtered by: ' + jQuery(this).text();
    var data = {
      'action': 'articles_filter',
      'term_ID': jQuery(this).attr('data-term_ID')
    };
    jQuery('.cards .container>h3').text(text);
    jQuery.ajax({
      url: myajax.url,
      type: 'POST',
      data: data,
      dataType: "json",
      success: function success(result) {
        if (result) {
          jQuery('.cards__row').html(result.posts);
          jQuery('a.btn.btn_load_more').attr('data-count_posts', result.count);

          if (result.count < 7) {
            jQuery('a.btn.btn_load_more').hide();
          } else {
            jQuery('a.btn.btn_load_more').show();
          }

          jQuery('.articles-filter__form-col select').each(function (i) {
            jQuery(this).prop('selectedIndex', 0);
            jQuery(this).parent().find('.custom-select-opener span').text(jQuery(this).find('option:first').text());
            jQuery(this).parent().find('.custom-select-panel div').each(function (i) {
              if (i == 0) {
                jQuery(this).addClass('is-selected has-focus');
              } else {
                jQuery(this).removeClass('is-selected has-focus');
              }
            });
          });
          jQuery('.articles-filter__form-head [role="search"] [type="search"]').val('');
        }
      }
    });
  });
  jQuery('.articles-filter__form-row .reset__filter ').on('click', function (e) {
    e.preventDefault();
    var data = {
      'action': 'articles_filter',
      'term_ID': 'reset_filter'
    };
    jQuery('.cards .container>h3').text('ALL ARTICLES');
    jQuery.ajax({
      url: myajax.url,
      type: 'POST',
      data: data,
      dataType: "json",
      success: function success(result) {
        if (result) {
          jQuery('.cards__row').html(result.posts);
          jQuery('a.btn.btn_load_more').attr('data-count_posts', result.count);

          if (result.count < 7) {
            jQuery('a.btn.btn_load_more').hide();
          } else {
            jQuery('a.btn.btn_load_more').show();
          }

          jQuery('.articles-filter__form-col select').each(function (i) {
            jQuery(this).prop('selectedIndex', 0);
            jQuery(this).parent().find('.custom-select-opener span').text(jQuery(this).find('option:first').text());
            jQuery(this).parent().find('.custom-select-panel div').each(function (i) {
              if (i == 0) {
                jQuery(this).addClass('is-selected has-focus');
              } else {
                jQuery(this).removeClass('is-selected has-focus');
              }
            });
          });
          jQuery('.articles-filter__form-col .not_filter ').removeClass('active');
          jQuery('.articles-filter__form-head [role="search"] [type="search"]').val('');
        }
      }
    });
  });
  jQuery('.articles-filter a.btn.btn_load_more').on('click', function (e) {
    e.preventDefault();
    var search = jQuery('.articles-filter__form-head [role="search"]').val();
    var term_ID = 'all';
    var ids = [];

    if (jQuery('.articles-filter__form-col .not_filter ').hasClass('active')) {
      term_ID = jQuery('.articles-filter__form-col .not_filter ').attr('data-term_id');
    }

    jQuery('.articles-filter__form-col select').each(function (i) {
      if (jQuery(this).val() !== 'default') {
        term_ID = jQuery(this).val();
      }
    });
    jQuery('.cards__col').each(function () {
      ids.push(jQuery(this).attr('data-id'));
    });
    var data = {
      'action': 'load_more',
      'term_ID': term_ID,
      'ids': ids,
      'search': search
    }; // console.log(data);

    jQuery.ajax({
      url: myajax.url,
      type: 'POST',
      data: data,
      dataType: "json",
      success: function success(result) {
        if (result) {
          jQuery('.cards__row').append(result.posts);
          jQuery('a.btn.btn_load_more').attr('data-count_posts', result.count);

          if (result.count < 7) {
            jQuery('a.btn.btn_load_more').hide();
          } else {
            jQuery('a.btn.btn_load_more').show();
          }
        }
      }
    });
  });
  jQuery('#region-map path').on('mouseover', function () {
    var tabId = jQuery(this).attr('data-id');
    jQuery('#region-map path').removeClass('hover');
    jQuery('.region__list li a').removeClass('hover');
    jQuery('#region-map path[data-id="' + tabId + '"]').addClass('hover');
    jQuery("#" + tabId).addClass('hover');
  });
  jQuery('.region__list li a').on('mouseover', function () {
    var tabId = jQuery(this).attr('id');
    jQuery('#region-map path').removeClass('hover');
    jQuery('.region__list li a').removeClass('hover');
    jQuery(this).addClass('hover');
    jQuery('#region-map path[data-id="' + tabId + '"]').addClass('hover');
  });

  function updateTableRowColors() {
    setTimeout(function () {
      $('.job-board__table-tbody.list').each(function () {
        $(this).children('.job-board__table-row:visible').each(function (index) {
          $(this).css('background-color', index % 2 === 0 ? '#FFFFFF' : '#F9F9F9');
        });
      });
    }, 100);
  }

  jQuery('.job-board__table-filter-select select').change(function () {
    var filters = $.map($('.job-board__table-filter-select select').toArray(), function (e) {
      return $(e).val();
    }).join('.');
    jQuery('.job-board__table-tbody').find('>div').hide();
    jQuery('.job-board__table-tbody').find('>div.' + filters).show();
    updateTableRowColors();
  });
  jQuery('.job-board').on('click', function () {
    updateTableRowColors();
  });
  updateTableRowColors();
}); // temporary fix for the unclickable mobile menu links (blog, newsletter etc)

document.addEventListener('DOMContentLoaded', function () {
  var parentMenuItem = document.querySelector('#menu-item-596');
  var subMenuItems = parentMenuItem.querySelectorAll('.sub-menu li a');
  subMenuItems.forEach(function (item) {
    item.addEventListener('click', function (event) {
      event.preventDefault();
      window.location.href = event.target.href;
    });
  });
}); // fix layout content shift for gravity forms

jQuery(document).on('gform_post_render', function (event, formId, current_page) {
  var formWrapper = jQuery(".gform-wrapper[data-form-id=\"".concat(formId, "\"]"));

  if (formWrapper.length) {
    formWrapper.addClass('gform_loaded');
  }
});